(() => {
  if (window.__fuFilterController) return;
  window.__fuFilterController = true;
  document.documentElement.dataset.fuControllerVersion = '6';

  const drawerSelector = '#filters-drawer';
  const publisherNames = {
    'image-comics': 'Image Comics', idw: 'IDW', 'boom-studios': 'BOOM! Studios',
    dynamite: 'Dynamite', 'bad-idea': 'Bad Idea', 'mad-cave': 'Mad Cave',
    aftershock: 'AfterShock', humanoids: 'Humanoids',
    'merc-publishing': 'Merc Publishing', indies: 'Indies'
  };
  const publisherLogos = {
    'image-comics': 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-image_comics_black_logo.png?v=1791716569',
    idw: 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/idw-entertainment-black-white.png?v=1791893893',
    'boom-studios': 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-boom_studios_black_logo.png?v=1791716583',
    dynamite: 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-dynamite_publisher_logo.png?v=1791716590',
    'bad-idea': 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-bad_idea_logo_wordmark.png?v=1791716596',
    'mad-cave': 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-mad_cave_comics_logo.png?v=1791716603',
    aftershock: 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-shattered_aftershock_logo.png?v=1791717752',
    humanoids: 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-humanoids_h_lightning_logo.png?v=1791717757',
    'merc-publishing': 'https://cdn.shopify.com/s/files/1/0738/0339/9270/files/publisher-distressed_merc_publishing_logo.png?v=1791717763'
  };
  let countController = null;
  let countTimer = 0;
  let lastForm = null;
  const pageCache = new Map();

  function drawer() { return document.querySelector(drawerSelector); }
  function form() { return drawer()?.querySelector('form.facets__form'); }
  function formComponent() { return drawer()?.querySelector('facets-form-component'); }
  function defaultSort() { return form()?.dataset.defaultSortBy || 'manual'; }
  function normalizedPublisher(value) {
    const raw = String(value || '').toLowerCase().trim();
    const aliases = {
      'idw publishing': 'idw', 'boom studios': 'boom-studios', 'boom! studios': 'boom-studios',
      'image comics': 'image-comics', 'dynamite entertainment': 'dynamite',
      'mad cave comics': 'mad-cave', 'mad cave studios': 'mad-cave',
      'aftershock comics': 'aftershock', 'merc publishing': 'merc-publishing'
    };
    if (raw.startsWith('idw-publishing')) return 'idw';
    if (raw.startsWith('image-comics')) return 'image-comics';
    if (raw.startsWith('boom-studios')) return 'boom-studios';
    if (raw.startsWith('dynamite-entertainment')) return 'dynamite';
    return aliases[raw] || raw.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function collectDraftURL() {
    const f = form();
    if (!f) return new URL(location.href);
    const url = new URL(location.href);
    const params = url.searchParams;
    for (const key of [...params.keys()]) {
      if (key.startsWith('filter.') || key.startsWith('fu_') || key === 'sort_by' || key === 'page') params.delete(key);
    }
    f.querySelectorAll('input').forEach(input => {
      if (!(input instanceof HTMLInputElement)) return;
      const key = input.name;
      if (!(key.startsWith('filter.') || key.startsWith('fu_') || key === 'sort_by')) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) params.append(key, input.value);
      } else if (input.value.trim() !== '') {
        params.append(key, input.value.trim());
      }
    });
    return url;
  }
  function syncControls(params) {
    const f = form();
    if (!f) return;
    f.querySelectorAll('input').forEach(input => {
      if (!(input instanceof HTMLInputElement)) return;
      const values = params.getAll(input.name);
      if (input.type === 'checkbox' || input.type === 'radio') {
        const selected = input.name === 'sort_by' ? (params.get('sort_by') || defaultSort()) : null;
        input.checked = input.name === 'sort_by' ? input.value === selected : values.includes(input.value);
      } else if (input.name.startsWith('filter.v.price.')) {
        input.value = params.get(input.name) || '';
      }
    });
  }
  function countActive(params) {
    let count = 0;
    let hasPrice = false;
    for (const [key, value] of params.entries()) {
      if (!value) continue;
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') hasPrice = true;
      else if (key.startsWith('filter.') || key.startsWith('fu_')) count++;
    }
    if (hasPrice) count++;
    const sort = params.get('sort_by');
    if (sort && sort !== defaultSort()) count++;
    return count;
  }
  function inputLabel(input) {
    const direct = input.dataset.label;
    if (direct) return direct;
    const label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
    return (label?.innerText || input.value || input.name).trim();
  }
  function renderPills(params) {
    const wrap = drawer()?.querySelector('.facets-remove--mobile-and-vertical');
    if (!wrap) return;
    const heading = wrap.querySelector('h3');
    const ref = wrap.querySelector('facet-remove-component.facets-remove__pill');
    wrap.replaceChildren();
    if (heading) wrap.append(heading);
    const records = [];
    const f = form();
    if (!f) return;
    for (const input of f.querySelectorAll('input:checked')) {
      if (input.name === 'sort_by' && input.value === defaultSort()) continue;
      records.push({ label: inputLabel(input), name: input.name, value: input.value });
    }
    const low = f.querySelector('[name="filter.v.price.gte"]');
    const high = f.querySelector('[name="filter.v.price.lte"]');
    if (low?.value || high?.value) records.push({ label: [low?.value || '0', high?.value || '∞'].join(' – '), name: 'filter.v.price.gte', value: '__price__' });
    records.forEach(record => {
      const pill = document.createElement('facet-remove-component');
      pill.className = 'pills__pill pills__pill--desktop-small facets-remove__pill fu-draft-pill';
      pill.setAttribute('role', 'button');
      pill.setAttribute('tabindex', '0');
      pill.dataset.fuName = record.name;
      pill.dataset.fuValue = record.value;
      pill.append(document.createTextNode(record.label));
      const icon = ref?.querySelector('.svg-wrapper')?.cloneNode(true);
      const cross = icon || document.createElement('span');
      if (!icon) { cross.className = 'svg-wrapper svg-wrapper--smaller'; cross.textContent = '×'; }
      pill.append(cross);
      wrap.append(pill);
    });
  }
  function updateCounters(params, count) {
    const active = countActive(params);
    document.querySelectorAll(drawerSelector + ' .theme-drawer__badge,' + drawerSelector + ' #filters-drawer-bubble,' + drawerSelector + ' .filter-count-bubble__text').forEach(el => {
      el.textContent = String(active);
      el.hidden = active === 0;
      el.style.display = active ? '' : 'none';
    });
    document.querySelectorAll('.fu-toolbar-filter-number').forEach(el => {
      el.textContent = String(active);
      el.hidden = active === 0;
    });
    const button = drawer()?.querySelector('[data-fu-apply]');
    if (button) {
      button.disabled = !Number.isFinite(count);
      button.setAttribute('aria-busy', Number.isFinite(count) ? 'false' : 'true');
      if (Number.isFinite(count)) {
        button.textContent = 'SHOW ' + count + ' ITEMS';
        button.setAttribute('aria-label', 'Show ' + count + ' items');
      } else {
        button.textContent = 'CALCULATING…';
        button.setAttribute('aria-label', 'Calculating result count');
      }
    }
    renderPills(params);
  }
  function getPages(doc, url) {
    const searchGrid = doc.querySelector('.fu-search-grid');
    if (searchGrid) return Math.max(1, Number(searchGrid.dataset.pages || 1));
    const links = [...doc.querySelectorAll('.fu-original-pagination a')].map(a => Number(a.textContent.trim())).filter(Number.isFinite);
    return Math.max(1, ...links, Number(url.searchParams.get('page') || 1));
  }
  async function fetchHTML(url, signal) {
    const key = url.href;
    const cached = pageCache.get(key);
    if (cached && Date.now() - cached.time < 1500) return cached.html;
    const response = await fetch(key, { credentials: 'same-origin', signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Filter result request failed: ' + response.status);
    const html = await response.text();
    pageCache.set(key, { time: Date.now(), html });
    return html;
  }
  async function loadAllDocuments(url, signal) {
    // Always begin at page one. A filtered search opened from page two must still
    // aggregate every result page, instead of loading page two twice.
    const firstPageURL = new URL(url.href);
    firstPageURL.searchParams.delete('page');
    const firstHTML = await fetchHTML(firstPageURL, signal);
    const firstDoc = new DOMParser().parseFromString(firstHTML, 'text/html');
    const pages = getPages(firstDoc, firstPageURL);
    const requests = [];
    for (let page = 2; page <= pages; page++) {
      const pageUrl = new URL(firstPageURL.href);
      pageUrl.searchParams.set('page', String(page));
      requests.push(fetchHTML(pageUrl, signal).then(html => new DOMParser().parseFromString(html, 'text/html')));
    }
    return [firstDoc, ...await Promise.all(requests)];
  }
  function matchesCGCVariant(card, params) {
    const price = Number(card.dataset.fuCgcPrice);
    const available = card.dataset.fuCgcAvailable === 'true';
    const min = params.has('filter.v.price.gte') ? Number(params.get('filter.v.price.gte')) : null;
    const max = params.has('filter.v.price.lte') ? Number(params.get('filter.v.price.lte')) : null;
    if (min !== null && (!Number.isFinite(price) || price < min)) return false;
    if (max !== null && (!Number.isFinite(price) || price > max)) return false;
    if (params.get('filter.v.availability') === '1' && !available) return false;
    if (params.get('filter.v.availability') === '0' && available) return false;
    return true;
  }
  function cgcCandidateURL(url) {
    const candidate = new URL(url.href);
    for (const key of [...candidate.searchParams.keys()]) {
      if (key === 'filter.v.availability' || key.startsWith('filter.v.price.')) candidate.searchParams.delete(key);
    }
    candidate.searchParams.delete('page');
    return candidate;
  }
  function getSearchTokens(params) {
    const query = params.get('q') || '';
    return (query.match(/[\p{L}\p{N}]+/gu) || []).map(token => token.toLocaleLowerCase());
  }
  function matchesSearchTerms(card, params) {
    const requested = getSearchTokens(params);
    if (!requested.length) return true;
    const searchText = [
      card.dataset.publisher || '',
      card.querySelector('.fu-search-copy')?.textContent || '',
      card.querySelector('.fu-search-media img')?.alt || ''
    ].join(' ');
    const available = new Set((searchText.match(/[\p{L}\p{N}]+/gu) || []).map(token => token.toLocaleLowerCase()));
    return requested.every(token => available.has(token));
  }
  function matchesScope(card, params, isSearch) {
    if (isSearch && !matchesSearchTerms(card, params)) return false;
    const categories = params.getAll('fu_collection');
    const publishers = params.getAll('fu_publisher');
    if (isSearch && categories.length) {
      const available = (card.dataset.collections || '').split(/\s+/).filter(Boolean);
      if (!categories.some(value => available.includes(value))) return false;
    }
    if (publishers.length) {
      const publisher = normalizedPublisher(card.dataset.publisher || card.querySelector('.fu-comic-card__publisher,.fu-search-pub')?.textContent);
      if (!publishers.includes(publisher)) return false;
    }
    if (!isSearch && location.pathname.replace(/\/$/, '') === '/collections/cgc-1' && !matchesCGCVariant(card, params)) return false;
    return true;
  }
  async function collectMatchingCGCCards(url, signal) {
    const docs = await loadAllDocuments(cgcCandidateURL(url), signal);
    const unique = new Set();
    const cards = [];
    for (const doc of docs) {
      for (const card of doc.querySelectorAll('.fu-original-collection .fu-original-grid > .fu-original-card')) {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) continue;
        const href = new URL(link.href, location.href);
        const key = href.pathname + (href.searchParams.has('variant') ? '?variant=' + href.searchParams.get('variant') : '');
        if (unique.has(key)) continue;
        unique.add(key);
        if (matchesScope(card, url.searchParams, false)) cards.push(card.cloneNode(true));
      }
    }
    const sort = url.searchParams.get('sort_by') || 'manual';
    if (sort === 'price-ascending' || sort === 'price-descending') {
      cards.sort((a, b) => Number(a.dataset.fuCgcPrice) - Number(b.dataset.fuCgcPrice));
      if (sort === 'price-descending') cards.reverse();
    }
    return cards;
  }
  async function exactDraftCount(url, signal) {
    const isSearch = url.pathname === '/search';
    const isCGC = url.pathname.replace(/\/$/, '') === '/collections/cgc-1';
    const hasCGCVariantFilters = isCGC && (url.searchParams.has('filter.v.availability') || [...url.searchParams.keys()].some(key => key.startsWith('filter.v.price.')));
    const hasSearchTerms = isSearch && getSearchTokens(url.searchParams).length > 0;
    const hasClientScope = url.searchParams.has('fu_collection') || url.searchParams.has('fu_publisher') || hasCGCVariantFilters || hasSearchTerms;
    if (!hasClientScope && url.href === window.location.href) {
      const currentCount = Number(formComponent()?.dataset.resultsCount);
      if (Number.isFinite(currentCount) && currentCount >= 0) return currentCount;
    }
    if (!hasClientScope) {
      const html = await fetchHTML(url, signal);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const serverCount = Number(doc.querySelector('facets-form-component')?.dataset.resultsCount);
      if (Number.isFinite(serverCount) && serverCount >= 0) return serverCount;
    }
    if (isCGC) return (await collectMatchingCGCCards(url, signal)).length;
    const docs = await loadAllDocuments(hasCGCVariantFilters ? cgcCandidateURL(url) : url, signal);
    let count = 0;
    for (const doc of docs) {
      const cards = doc.querySelectorAll(isSearch ? '.fu-search-grid .fu-search-card' : '.fu-original-collection .fu-original-grid > .fu-original-card');
      cards.forEach(card => { if (matchesScope(card, url.searchParams, isSearch)) count++; });
    }
    return count;
  }
  function scheduleCount() {
    clearTimeout(countTimer);
    if (countController) countController.abort();
    countController = new AbortController();
    const url = collectDraftURL();
    const params = url.searchParams;
    updateCounters(params, NaN);
    countTimer = window.setTimeout(async () => {
      const controller = countController;
      try {
        const count = await exactDraftCount(url, controller.signal);
        if (!controller.signal.aborted) updateCounters(params, count);
      } catch (error) {
        if (error.name !== 'AbortError') {
          const button = drawer()?.querySelector('[data-fu-apply]');
          if (button) {
            button.disabled = true;
            button.textContent = 'COUNT UNAVAILABLE';
            button.setAttribute('aria-busy', 'true');
            button.setAttribute('aria-label', 'Result count unavailable');
          }
          console.warn('[FU filters] Count preview failed', error);
        }
      }
    }, 120);
  }
  function clearDraft() {
    const f = form();
    if (!f) return;
    f.querySelectorAll('input').forEach(input => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
      else input.value = '';
    });
    const sort = f.querySelector('[name="sort_by"][value="' + CSS.escape(defaultSort()) + '"]');
    if (sort) sort.checked = true;
    scheduleCount();
  }
  function removeDraftPill(target) {
    const f = form();
    if (!f) return;
    const name = target.dataset.fuName;
    const value = target.dataset.fuValue;
    if (value === '__price__') {
      f.querySelectorAll('[name="filter.v.price.gte"],[name="filter.v.price.lte"]').forEach(input => { input.value = ''; });
    } else {
      f.querySelectorAll('input[name="' + CSS.escape(name) + '"]').forEach(input => {
        if (input.value === value) input.checked = false;
      });
      if (name === 'sort_by') {
        const sort = f.querySelector('[name="sort_by"][value="' + CSS.escape(defaultSort()) + '"]');
        if (sort) sort.checked = true;
      }
    }
    scheduleCount();
  }
  async function applyDraft() {
    const url = collectDraftURL();
    if (url.href === location.href) {
      drawer()?.close?.();
      return;
    }
    location.assign(url.href);
  }

  function searchPaginationURL(href) {
    const target = new URL(location.href);
    const requestedPage = new URL(href, location.href).searchParams.get('page');
    target.searchParams.delete('page');
    if (requestedPage) target.searchParams.set('page', requestedPage);
    return target;
  }
  function installSearchPaginationGuard() {
    if (location.pathname !== '/search') return;
    const pagination = document.querySelector('.fu-search-pagination');
    if (!pagination) return;
    pagination.querySelectorAll('a[href]').forEach(link => {
      link.href = searchPaginationURL(link.href).href;
    });
    if (document.documentElement.dataset.fuSearchPaginationGuard === 'true') return;
    document.documentElement.dataset.fuSearchPaginationGuard = 'true';
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('.fu-search-pagination a[href]');
      if (!link) return;
      event.preventDefault();
      location.assign(searchPaginationURL(link.href).href);
    }, true);
  }
  function install() {
    const f = form();
    const d = drawer();
    if (!f || f.dataset.fuController === 'true') return;
    f.dataset.fuController = 'true';
    lastForm = f;
    const params = new URL(location.href).searchParams;
    syncControls(params);
    scheduleCount();

    document.addEventListener('change', event => {
      if (!(event.target instanceof Element) || !event.target.closest(drawerSelector)) return;
      const input = event.target.closest('input');
      if (!input) return;
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (input.name === 'sort_by' && input.type === 'checkbox' && input.checked) {
        f.querySelectorAll('input[name="sort_by"]').forEach(other => { if (other !== input) other.checked = false; });
      }
      scheduleCount();
    }, true);
    document.addEventListener('input', event => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.closest(drawerSelector)) return;
      if (!event.target.name.startsWith('filter.v.price.')) return;
      event.stopPropagation();
      event.stopImmediatePropagation();
      scheduleCount();
    }, true);
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const target = event.target.closest(drawerSelector + ' [data-fu-apply]');
      if (target) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        applyDraft();
        return;
      }
      const clear = event.target.closest(drawerSelector + ' .facets__clear-all');
      if (clear) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        clearDraft();
        return;
      }
      const pill = event.target.closest(drawerSelector + ' .fu-draft-pill');
      if (pill) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        removeDraftPill(pill);
      }
    }, true);
    document.addEventListener('theme-drawer:open', event => {
      if (!(event.target instanceof Element) || !event.target.matches(drawerSelector)) return;
      scheduleCount();
    });
    document.addEventListener('theme-drawer:close', event => {
      if (!(event.target instanceof Element) || !event.target.matches(drawerSelector)) return;
      syncControls(new URL(location.href).searchParams);
      scheduleCount();
    });
    installSearchPaginationGuard();
    window.fuApplyPublisherGroups = applyCollectionPublisherFilter;
    window.fuApplyScopedFilters = applySearchScope;
    if (location.pathname === '/search') applySearchScope();
    else applyCollectionPublisherFilter();
  }
  async function applyCollectionPublisherFilter() {
    const path = location.pathname.replace(/\/$/, '');
    if (path === '/collections/comics') return applyComicGroups();
    if (path === '/collections/cgc-1') return applyCGCVariantFilter();
    if (path !== '/collections/original-art') return;
    const params = new URL(location.href).searchParams;
    const selected = params.getAll('fu_publisher');
    const activeNativeFilters = [...params.keys()].some(key => key.startsWith('filter.'));
    const root = document.querySelector('.fu-original-collection');
    const list = root?.querySelector('.fu-original-grid');
    if (!root || !list) return;
    if (!selected.length && !activeNativeFilters) {
      root.hidden = false;
      document.getElementById('fu-multiple-publisher-groups')?.remove();
      return;
    }
    try {
      const pageOne = new URL(location.href);
      pageOne.searchParams.delete('page');
      const docs = await loadAllDocuments(pageOne, new AbortController().signal);
      const matching = [];
      const seen = new Set();
      for (const doc of docs) {
        doc.querySelectorAll('.fu-original-collection .fu-original-grid > .fu-original-card').forEach(card => {
          const link = card.querySelector('a[href*="/products/"]');
          const key = link ? new URL(link.href, location.href).pathname : '';
          if (!key || seen.has(key)) return;
          seen.add(key);
          if (matchesScope(card, params, false)) matching.push(card.cloneNode(true));
        });
      }
      if (selected.length) {
        renderPublisherGroups(root, matching, selected);
      } else {
        root.hidden = false;
        document.getElementById('fu-multiple-publisher-groups')?.remove();
        list.replaceChildren(...matching);
      }
      const pagination = root.querySelector('.fu-original-pagination');
      if (pagination) pagination.hidden = true;
      updateCollectionResultCount(root, matching.length);
    } catch (error) {
      if (error.name !== 'AbortError') console.error('[FU filters] Collection publisher results failed', error);
    }
  }
  async function applyCGCVariantFilter() {
    const params = new URL(location.href).searchParams;
    const scoped = params.has('fu_publisher') || params.has('filter.v.availability') || [...params.keys()].some(key => key.startsWith('filter.v.price.'));
    const root = document.querySelector('.fu-original-collection');
    const list = root?.querySelector('.fu-original-grid');
    if (!root || !list) return;
    if (!scoped) {
      root.hidden = false;
      document.getElementById('fu-multiple-publisher-groups')?.remove();
      return;
    }
    try {
      const selected = await collectMatchingCGCCards(new URL(location.href), new AbortController().signal);
      const selectedPublishers = params.getAll('fu_publisher');
      if (selectedPublishers.length) {
        renderPublisherGroups(root, selected, selectedPublishers);
      } else {
        root.hidden = false;
        document.getElementById('fu-multiple-publisher-groups')?.remove();
        list.replaceChildren(...selected);
      }
      const pagination = root.querySelector('.fu-original-pagination');
      if (pagination) pagination.hidden = true;
      updateCollectionResultCount(root, selected.length);
    } catch (error) {
      if (error.name !== 'AbortError') console.error('[FU filters] CGC variant results failed', error);
    }
  }
  function updateCollectionResultCount(root, count) {
    const countNode = document.querySelector('.products-count-wrapper');
    if (countNode) countNode.textContent = count + (count === 1 ? ' item' : ' items');
    const toolbarCount = document.querySelector('.fu-editorial-toolbar .fu-editorial-count');
    if (toolbarCount) toolbarCount.textContent = count + ' products';
    let empty = root.querySelector('[data-fu-collection-empty]');
    if (!count) {
      if (!empty) { empty = document.createElement('p'); empty.dataset.fuCollectionEmpty = 'true'; empty.textContent = 'No products match these filters.'; root.append(empty); }
    } else empty?.remove();
  }
  function renderPublisherGroups(root, cards, selected) {
    const areaId = 'fu-multiple-publisher-groups';
    let area = document.getElementById(areaId);
    if (!selected.length) {
      root.hidden = false;
      area?.remove();
      return cards.length;
    }
    if (!area) {
      area = document.createElement('div');
      area.id = areaId;
      root.after(area);
    }
    root.hidden = true;
    area.replaceChildren();
    let total = 0;
    for (const rawHandle of selected) {
      const handle = normalizedPublisher(rawHandle);
      const matching = cards.filter(card => {
        const value = card.dataset.publisher || card.querySelector('.fu-comic-card__publisher,.fu-card-publisher')?.textContent;
        return normalizedPublisher(value) === handle;
      });
      if (!matching.length) continue;
      total += matching.length;
      const section = document.createElement('section');
      section.className = 'fu-publisher-selected-group fu-original-collection fu-publisher-collection';
      const heading = document.createElement('h2');
      const imgUrl = publisherLogos[handle];
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = '';
        img.width = 100;
        img.height = 60;
        heading.append(img);
      }
      heading.append(document.createTextNode(publisherNames[handle] || handle));
      section.append(heading);
      const list = document.createElement('ul');
      list.className = 'fu-original-grid';
      list.setAttribute('role', 'list');
      matching.forEach(card => list.append(card.cloneNode(true)));
      section.append(list);
      area.append(section);
    }
    if (!total) {
      const empty = document.createElement('p');
      empty.textContent = 'No products match these filters.';
      area.append(empty);
    }
    return total;
  }
  async function applyComicGroups() {
    if (location.pathname.replace(/\/$/, '') !== '/collections/comics') return;
    const params = new URL(location.href).searchParams;
    const selected = params.getAll('fu_publisher');
    const main = document.querySelector('.fu-original-collection');
    if (!main) return;
    if (!selected.length) {
      renderPublisherGroups(main, [], []);
      const counter = document.querySelector('.fu-editorial-toolbar .fu-editorial-count');
      if (counter) counter.textContent = String(main.querySelectorAll('.fu-original-card').length) + ' products';
      return;
    }
    const counter = document.querySelector('.fu-editorial-toolbar .fu-editorial-count');
    try {
      const url = new URL(location.href);
      const docs = await loadAllDocuments(url, new AbortController().signal);
      const allCards = [];
      const seen = new Set();
      for (const doc of docs) {
        doc.querySelectorAll('.fu-original-collection .fu-original-grid > .fu-original-card').forEach(card => {
          const link = card.querySelector('a[href*="/products/"]');
          const key = link ? new URL(link.href, location.href).pathname : '';
          if (key && !seen.has(key)) { seen.add(key); allCards.push(card); }
        });
      }
      const total = renderPublisherGroups(main, allCards, selected);
      if (counter) counter.textContent = total + ' products';
    } catch (error) {
      if (error.name !== 'AbortError') console.error('[FU filters] Publisher results failed', error);
    }
  }
  async function applySearchScope() {
    if (location.pathname !== '/search') return;
    const params = new URL(location.href).searchParams;
    const categories = params.getAll('fu_collection');
    const publishers = params.getAll('fu_publisher');
    const grid = document.querySelector('.fu-search-grid');
    if (!grid) return;
    const pagination = document.querySelector('.fu-search-pagination');
    const hasSearchTerms = getSearchTokens(params).length > 0;
    if (!categories.length && !publishers.length && !hasSearchTerms) {
      grid.querySelectorAll('[data-fu-appended]').forEach(card => card.remove());
      grid.querySelectorAll('.fu-search-card').forEach(card => { card.hidden = false; });
      if (pagination) pagination.hidden = false;
      return;
    }
    try {
      const docs = await loadAllDocuments(new URL(location.href), new AbortController().signal);
      const selected = [];
      const seen = new Set();
      for (const doc of docs) {
        doc.querySelectorAll('.fu-search-grid .fu-search-card').forEach(card => {
          const link = card.querySelector('.fu-search-media');
          const key = link ? new URL(link.href, location.href).pathname : '';
          if (!key || seen.has(key)) return;
          seen.add(key);
          if (matchesScope(card, params, true)) selected.push(card.cloneNode(true));
        });
      }
      grid.replaceChildren(...selected);
      if (pagination) pagination.hidden = true;
      const count = document.querySelector('.fu-search-toolbar .fu-editorial-count');
      if (count) count.textContent = selected.length + ' products';
    } catch (error) {
      if (error.name !== 'AbortError') console.error('[FU filters] Search results failed', error);
    }
  }

  const formObserver = new MutationObserver(() => {
    const current = form();
    if (!current || current === lastForm) return;
    lastForm = current;
    current.dataset.fuController = 'true';
    syncControls(new URL(location.href).searchParams);
    scheduleCount();
  });
  formObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();